import * as React from "react";
import global from '../global';
import { withRouter } from "react-router-dom";
import logo from '../img/logo-unesa.png'

interface IState {
    isLogged:boolean,
    data: {
        username: string,
        password: string
    }
}

export class LoginPage extends React.Component<any, IState, History> {
    private url: any;
    constructor(props: any) {
        super(props);
        global.removeSession();
        localStorage.removeItem("token");
        localStorage.removeItem("profile");
        this.state = {
            isLogged:false,
            data:{
                username:"",
                password:""
            }
        };
    }

    componentWillMount() {
        this.url = window.location.origin;
        if (window.location.port === "8080") {
            this.url = this.url.replace("8080", "3000");
        } else if(window.location.port === "") {
            this.url = this.url + ":1000";
        } 
    }

    handleChange(e: any) {
        let data = this.state.data;
        data[e.target.name] = e.target.value;
        this.setState({ data });
    }

    handleSubmit() {
        const { history } = this.props;
        $.ajax({
            type: "POST",
            url: this.url + "/api/login",
            data: { data: JSON.stringify(this.state.data) },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                if (!!res.msg) alert(res.msg);
                else alert("Error !!!");
            } else {
                let data = res.msg;
                if(!!data.token)
                {
                    localStorage.setItem('token', data.token);
                }
                global.setSession({
                    cid:data.token,
                    user:{
                        id: parseInt(data.id),
                        fullname: data.fullname,
                        role: data.role,
                        username: data.username
                    }
                });

                localStorage.setItem('profile', JSON.stringify(global.session));
                if(history){
                    if(data.role == "admin") history.replace("/admin");
                    else history.replace('/');
                }
            }
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
        });
    }

    render() {
        return <div>
        <div  style={{backgroundColor:"#4FAED2", height:"100%",width:"100%",zIndex:-99999, position:"fixed"}}/>
        <div className="columns">
        <div className="column col-12" style={{display:"flex",justifyContent:"center",color:"#fff",marginTop:"10%"}} >
                <img src={logo} style={{width:"5%"}} /><br/>
            </div>
            <div className="column col-12" style={{display:"flex",justifyContent:"center",color:"#fff"}} >
                <h3>SISTEM ANALISA LEMA</h3>
            </div>
            <div className="column col-12" style={{display:"flex",justifyContent:"center"}} >
                <div className="panel" style={{backgroundColor:"#fff",}}>
                    <div className="panel-header" style={{ borderBottom: "1px solid #e7e9ec" }}>
                        <div className="panel-title" style={{display:"flex",justifyContent:"center"}}>
                            <h5>LOGIN</h5>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className="card-body">
                            <form className="form-horizontal">
                                <div className="form-group">
                                    <div className="col-4 col-sm-12">
                                        <label className="form-label">Username</label>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <input className="form-input" type="text" onChange={(e) => this.handleChange(e)} name="username" value={this.state.data.username} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="col-4 col-sm-12">
                                        <label className="form-label">Password</label>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <input className="form-input" type="password" onChange={(e) => this.handleChange(e)} name="password" value={this.state.data.password} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="panel-footer" style={{ textAlign: "right" }}>
                        <button className="col-12 btn btn-success" onClick={() => this.handleSubmit()}>
                        Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
}

export default withRouter(LoginPage);


// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx